import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Button,
  ButtonGroup,
  Container,
  Row,
  Col,
  Form,
  Modal,
  Spinner,
  Card,
  Alert
} from "react-bootstrap";

import * as Yup from "yup";
import moment from "moment";
import { Formik } from "formik";
import { Typeahead } from "react-bootstrap-typeahead";

//Tabla, Navbar y Sidebar
import CustomNavbar from "../../../components/CustomNavbar";
import CustomTable from "../../../components/CustomTable";
import CustomPagint from "../../../components/CustomPagint";
import SidebarCarreraSucesion from "../../../components/Carrera_Sucesion/SidebarCarreraSucesion";

//Redux
import {
  getFactorCriterion,
  getFactors,
  getCriteria,
  getTasks,
  editFactorCriterion,
  saveFactorCriterion,
  deleteFactorCriterion,
  cleanFactorsCriteria
} from "../../../redux/Carrera_Sucesion/FactoresCriterios/actions";

import messages from "../../../redux/messages";
const FactoresCriterios = (props) => {
  const filters = [
    { id: "nombre_criterio", desc: "Nombre del criterio" },
    { id: "nombre_factor", desc: "Nombre del factor" },
    { id: "peso", desc: "Peso" },
    { id: "fecha_creacion", desc: "Fecha de creación" },
  ];

  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  //
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [editFactor, setEditFactor] = useState({});
  const [editCriterio, setEditCriterio] = useState({});
  const [editFuncion, setEditFuncion] = useState({});
  const [hasSearched, setHasSearched] = useState(false);
  const [factorSelected, setFactorSelected] = useState([]);
  const [_factor, setFactor] = useState(false);
  const [funcionSelected, setFuncionSelected] = useState([]);
  const [_funcion, setFuncion] = useState(false);
  const [criterioSelected, setCriterioSelected] = useState([]);
  const [_criterio, setCriterio] = useState(false);
  //
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState("");
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);

  //
  const [busqFuncion, setBusqFuncion] = useState("")
  const [busqAnio, setBusqAnio] = useState("")

  const [tipoBusqueda, setTipoBusqueda] = useState({
    id: "nombre_criterio",
    desc: "Nombre del Criterio",
  });
  const dispatch = useDispatch();

  const {
    loading,
    loadingById,
    saveLoading,
    factorsCriteriaLength,
    factorsCriteria,
    factorCriterion,
    factorCriterionError,
    factorsLength,
    factors,
    factorError,
    criterion,
    criteria,
    tasks,
    weightsPerTask,
    formError,
    loadingTask
  } = useSelector((store) => store.factorCriterion);
  const pages = Math.ceil(factorsCriteriaLength / limit);

  //Validacion del form
  const schema = Yup.object().shape({
    criterio: Yup.string().required("**Campo requerido"),
    factor_criticidad: Yup.string().required("**Campo requerido"),
    funcion: Yup.string().required("**Campo requerido"),
    peso: Yup.number().required().positive().integer()
      .test(
        'peso-total',
        'La suma de los pesos por función debe ser menor o igual a 100',
        function (value) {
          const { prevPeso } = this.parent;
          const cod_funcion = funcionSelected[0] ? funcionSelected[0].item.codigo : editFuncion?.[0] ? editFuncion?.[0].codigo : 0

          const currentWeight = weightsPerTask[cod_funcion] ? weightsPerTask[cod_funcion].peso : 0;
          const adjustedWeight = edit ? (currentWeight - prevPeso + value) : (currentWeight + value);
          console.log("ajuste", adjustedWeight, currentWeight)
          return adjustedWeight <= 100;
        }
      ),
  });




  //Factores
  let factorsOptions = [];
  factors &&
    // eslint-disable-next-line array-callback-return
    factors.map((factor) => {
      factorsOptions = [
        ...factorsOptions,
        {
          id: factor.id,
          label: factor.nombre
            ? `${factor.nombre.toUpperCase()}`
            : "",
          factor_id: factor.id,

          item: factor,
        },
      ];
    });

  //Criterios
  let criterioOptions = [];
  criteria &&
    // eslint-disable-next-line array-callback-return
    criteria.map((criterion) => {
      criterioOptions = [
        ...criterioOptions,
        {
          id: criterion.id,
          label: criterion.nombre
            ? `${criterion.nombre.toUpperCase()}`
            : "",
          item: criterion,
        },
      ];
    });

  //Funciones
  let tasksOptions = [];
  tasks &&
    // eslint-disable-next-line array-callback-return
    tasks.map((task) => {
      tasksOptions = [
        ...tasksOptions,
        {
          id: task.id,
          label: task.descripcion
            ? `${task.codigo} / ${task.descripcion.toUpperCase()}`
            : "",
          task_id: task.id,

          item: task,
        },
      ];
    });

  //Datos para el custom table
  const columns = [
    {
      Header: "Factor",
      accessor: "nombre_factor",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.list_factor_criticidad &&
            value.row.original.list_factor_criticidad[0]
            ? value.row.original.list_factor_criticidad[0].nombre
            : "No ingresado"}
        </div>
      )
    },
    {
      Header: "Criterio",
      accessor: "nombre_criterio",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.list_criterios &&
            value.row.original.list_criterios[0]
            ? value.row.original.list_criterios[0].nombre
            : "No ingresado"}
        </div>
      ),
    },
    {
      Header: "Función",
      accessor: "nombre_funcion",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.list_funcion &&
            value.row.original.list_funcion[0]
            ? value.row.original.list_funcion[0].codigo + " | " + value.row.original.list_funcion[0].descripcion
            : "No ingresado"}
        </div>
      ),
    },
    {
      Header: "Fecha de creación",
      accessor: "fecha_creacion",
      Filter: "",
      Cell: (value) => (
        <div>
          {moment(value.row.original.fecha_creacion).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      Header: "Peso",
      accessor: "peso",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.peso} %
        </div>
      )
    },
    {
      Header: "Año",
      accessor: "anio",
      Filter: ""
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="button-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(
              value.row.original,
              value.row.original.list_factor_criticidad &&
              value.row.original.list_factor_criticidad,
              value.row.original.list_criterios &&
              value.row.original.list_criterios,
              value.row.original.list_funcion &&
              value.row.original.list_funcion,
              value.row.index
            )}
          >
            <i className="material-icons">edit</i>
          </Button>
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            onClick={() => onDelete(value.row.original.id, value.row.index)}
          >
            <i className="material-icons">close</i>
          </Button>
        </div>
      ),
    },
  ];




  // Metodos de factores criterios 
  const getAFactorCriterion = (off = offset, lim = limit) =>
    dispatch(
      getFactorCriterion({
        offset: off,
        limit: lim,
        tipo_busqueda: "codigo_funcion",
        filter: busqFuncion,
        anio: busqAnio

      })
    );


  const getAFactor = () =>
    dispatch(
      getFactors()
    );

  const getACriterio = () =>
    dispatch(
      getCriteria()
    );

  const getAFuncion = () =>
    dispatch(
      getTasks()
    );

  const _cleanFactorsCriteria = () =>
    dispatch(
      cleanFactorsCriteria()
    );



  useEffect(() => {
    getAFactor();
    getACriterio();
    getAFuncion()
    _cleanFactorsCriteria()
  }, []);



  const searchFactorsCriteria = () => {
    if (busqAnio !== "" && busqFuncion !== "") {
      console.log(busqAnio)
      console.log(busqFuncion)
      getAFactorCriterion();
      setHasSearched(true)

    }
  }

  const addFactorCriterion = () => {
    setShowModal(true);
    setEdit(false);
    setValidated(false);
  };

  const onEdit = (item, factor, criterio, funcion, index) => {

    setIndex(index);
    setEdit(true);
    setEditFactor(factor);
    setEditCriterio(criterio);
    setEditFuncion(funcion);
    setEditItem(item);
    setShowModal(true);
    setValidated(false);
  };


  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(0);
    setCurrentPage(1);
    getAFactorCriterion(oOffset, limit, e.target.filter.value);
  };


  const onSubmit = async (req) => {

    const _req = {
      ...req,

      factor_criticidad: req.factor_criticidad,
      criterio: req.criterio,
      funcion: req.funcion,
      peso: req.peso,
      anio: moment(new Date()).format("YYYY"),
      fecha_creacion: moment(new Date()).format("YYYY-MM-DD"),
    };
    console.log(_req)
    if (!edit) {
      dispatch(saveFactorCriterion(_req, setShowModal));
    } else {
      dispatch(editFactorCriterion(_req, editItem.id, index, setShowModal));
    }
  };



  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getAFactorCriterion(oOffset, limit, oSearch);
  };

  const onDelete = (id, index) => {

    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteFactorCriterion(id, index));
      window.alert("Se borró este factor criterio");
    }
  };




  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarCarreraSucesion show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h6>Factores Criterios</h6>
            <Form onSubmit={onSearch}>
              <Row className="justify-content-sm-end align-items-center flex-nowrap">

                <Col xs="auto">
                  {busqAnio && busqFuncion && (
                    <ButtonGroup>
                      <Button
                        onClick={() => addFactorCriterion()}
                        variant="light"
                        size="sm"
                        className="rounded-circle"
                      >
                        <i className="material-icons">add</i>
                      </Button>
                    </ButtonGroup>
                  )}

                </Col>
              </Row>

            </Form>

          </div>
          <div className="px-2">
            <hr />
          </div>
          <Col md="12">
            {console.log("factores", factorsCriteria)}
            {factorsCriteriaLength == 0 && (
              <Row>
                <Col sm={12}>
                  <Alert variant="warning">
                    Seleccione una función y un año para crear y mostrar factores criterios.
                  </Alert>
                </Col>
           
              </Row>
            )}
            <Row>
              <Form.Group as={Col} md={8} className="mb-md-1">
                <Row>
                  <Form.Label column sm={3}>
                    Función
                  </Form.Label>
                  <Col sm={9}>
                    <Row className="d-flex flex-wrap justify-content-start align-items-center">

                      <Col sm={loading ? "10" : "12"}>
                        <Typeahead
                          id="busq_función"
                          name="busq_función"
                          placeholder="Seleccione una función"
                          options={tasksOptions}
                          onChange={(selected) => {
                            setBusqFuncion(selected.length > 0 ? selected[0].item.codigo : "")
                            console.log(selected)
                          }}
                          defaultInputValue={""}

                        >

                        </Typeahead>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Form.Group>
              <Form.Group as={Col} md={2} className="mb-md-1">
                <Row>
                  <Form.Label column sm={3}>
                    Año
                  </Form.Label>
                  <Col sm={9}>
                    <Row className="d-flex flex-wrap justify-content-start align-items-center">

                      <Col sm={loading ? "10" : "12"}>
                        <Form.Control
                          id="busq_anio"
                          name="busq_anio"
                          className="rounded-pill mb-4"
                          type="text"
                          placeholder="Año"
                          onChange={(event) => {
                            setBusqAnio(event.target.value)
                          }}
                        ></Form.Control>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Form.Group>
              <Form.Group as={Col} md={2} className="mb-md-1">
                <Button
                  onClick={searchFactorsCriteria}
                  variant="light"
                  size="sm"                  
                >
                  <i className="material-icons">search</i> Buscar
                </Button>
              </Form.Group>
            </Row>
          </Col>
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            factorsCriteria && factorsCriteria.length > 0 && (
              <>
                <Card className="border-0">
                  <Card.Body className="px-1 px-sm-2">
                    <CustomTable columns={columns} data={factorsCriteria} />
                  </Card.Body>
                </Card>
                <CustomPagint
                  limit={limit}
                  setLimit={setLimit}
                  offset={offset}
                  setOffset={setOffset}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  dataLenght={factorsCriteriaLength}
                  pages={pages}
                  pagFunc={getAFactorCriterion}

                />
              </>
            )
          )}
          {!loading && hasSearched && factorsCriteriaLength === 0 && busqFuncion !== "" && busqAnio !== "" && (
            <Alert variant="info" className="my-4">
              Aún no hay registros, comience creando algunos.
            </Alert>
          )}
          {!!factorCriterionError && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {factorCriterionError}
            </Alert>
          )}
        </Container>
      </div>

      <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
      >
        <Formik
          validationSchema={schema}
          onSubmit={onSubmit}
          initialValues={{
            id: edit ? editItem.id : "",
            criterio: edit ? editCriterio[0].id : "",
            factor_criticidad: edit ? editFactor[0].id : "",
            funcion: edit ? editFuncion[0].id : "",
            peso: edit ? editItem.peso : 0,
            prevPeso: edit ? editItem.peso : 0,
            cod_funcion: edit ? editFuncion[0].codigo : ""

          }}

        >

          {({
            handleSubmit,
            handleChange,
            handleBlur,
            setFieldValue,
            values,
            touched,
            errors,
          }) => (


            <Form onSubmit={handleSubmit} noValidate validated={validated}>
              <Modal.Header closeButton>
                <Modal.Title className="text-muted">
                  {edit ? "Editar Factor Criterio" : "Crear Factor Criterio"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!!formError && (
                  <Alert variant="danger" className={"mt-4 mb-1 mx-3"}>
                    {formError}
                  </Alert>
                )}

                <Form.Group className="mb-3">
                  <Form.Label column sm="12" md="12">
                    Factor:
                  </Form.Label>
                  <Row className="d-flex flex-wrap align-items-center">
                    <Col sm={11} xs={11}>
                      <Typeahead
                        id="factor"
                        name="factor"
                        isInvalid={touched.factor_criticidad && errors.factor_criticidad}
                        isValid={touched.factor_criticidad && !errors.factor_criticidad}
                        onBlur={handleBlur("Factor")}
                        placeholder="Seleccione un factor"
                        options={factorsOptions}
                        value={values.factor_criticidad}
                        onChange={(selected) => {
                          setFieldValue(
                            "factor_criticidad",
                            selected.length > 0 ? selected[0].id : "",

                          );
                          setFactorSelected(selected);
                          setFactor(selected.length > 0);


                        }}
                        defaultInputValue={edit ? `${editFactor[0].nombre}`
                          : ""}

                      >

                      </Typeahead>
                    </Col>
                  </Row>
                  <Form.Label column sm="12" md="12">
                    Criterio:
                  </Form.Label>
                  <Row className="d-flex flex-wrap align-items-center">
                    <Col sm={11} xs={11}>
                      <Typeahead
                        id="criterio"
                        name="criterio"
                        isInvalid={touched.criterio && errors.criterio}
                        isValid={touched.criterio && !errors.criterio}
                        onBlur={handleBlur("Criterio")}
                        placeholder="Seleccione un criterio"
                        options={criterioOptions}
                        value={values.criterio}
                        onChange={(selected) => {
                          setFieldValue(
                            "criterio",
                            selected.length > 0 ? selected[0].id : ""
                          );
                          setCriterioSelected(selected);
                          setCriterio(selected.length > 0);

                        }}
                        defaultInputValue={edit ? `${editCriterio[0].nombre}`
                          : ""}



                      ></Typeahead>
                    </Col>
                  </Row>
                  <Form.Label column sm="12" md="12">
                    Función:
                  </Form.Label>
                  <Row className="d-flex flex-wrap align-items-center">
                    <Col sm={11} xs={11}>
                      <Typeahead
                        id="funcion"
                        name="funcion"
                        isInvalid={touched.funcion && errors.funcion}
                        isValid={touched.funcion && !errors.funcion}
                        onBlur={handleBlur("Funcion")}
                        placeholder="Seleccione una función"
                        options={tasksOptions}
                        value={values.funcion}
                        onChange={(selected) => {
                          setFieldValue(
                            "funcion",
                            selected.length > 0 ? selected[0].id : "",

                          );
                          setFieldValue(
                            "cod_funcion",
                            selected.length > 0 ? selected[0].codigo : "",

                          );
                          setFuncionSelected(selected);
                          setFuncion(selected.length > 0);


                        }}
                        defaultInputValue={edit ? `${editFuncion[0].codigo} / ${editFuncion[0].descripcion}`
                          : ""}

                      >

                      </Typeahead>
                    </Col>
                  </Row>

                  <Form.Label column sm="12" md="12">
                    Peso:
                  </Form.Label>
                  <Row className="d-flex flex-wrap align-items-center">
                    <Col sm={11} xs={11}>
                      <Form.Control
                        id="peso"
                        name="peso"
                        isInvalid={touched.peso && errors.peso}
                        isValid={touched.peso && !errors.peso}
                        onBlur={handleBlur("peso")}
                        onChange={handleChange}
                        value={values.peso}
                        className="rounded-pill mb-4"
                        type="number"
                        placeholder="peso"
                      ></Form.Control>
                      <div class="invalid-feedback m-3" style={{ fontSize: "14px" }}>
                        {errors.peso}
                      </div>
                    </Col>
                  </Row>
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cerrar
                </Button>
                <Button
                  className="rounded-pill"
                  variant="primary"
                  disabled={saveLoading}
                  type="submit"


                >
                  {" "}
                  {saveLoading && (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />

                  )}
                  Guardar

                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>

      </Modal>

    </>
  );
};

export default FactoresCriterios;
